import { RestError } from "../../services/rest-service/RestService";
import { useMutation, useQueryClient } from "react-query";
import PageConfigurationService from "../../services/page-configuration-service/PageConfigurationService";
import { BaseUseMutationParameters } from "../BaseUseMutationParameters";
import { keys } from "./Keys";
import {keys as deviceSummaryKeys} from "../group-summary/devices/Keys";
import { keys as wellSummaryKeys } from "../group-summary/wells/Keys";
import { MutationContextType } from "./UseSavePageConfiguration";
import { PageConfigurationDataModel3, PageConfigurationTypeEnum } from "../../services/page-configuration-service/Models";

export type UseDeletePageConfigurationResultType = {
    deletedName: string;
};


export type DeleteConfigurationParameters = {
    configurationID: number,
    pageConfigurationType: PageConfigurationTypeEnum

}

export type UseDeletePageConfigurationParameters = {
    groupID: number,
    //configurationID: number;
    //pageConfigurationType: PageConfigurationTypeEnum;
} & BaseUseMutationParameters<UseDeletePageConfigurationResultType, DeleteConfigurationParameters>;

export function useDeletePageConfiguration({
    groupID,
    //configurationID,
    //pageConfigurationType,
    onError,
    onSuccess
}: UseDeletePageConfigurationParameters) {
    const queryClient = useQueryClient();


    return useMutation<UseDeletePageConfigurationResultType, RestError, DeleteConfigurationParameters, MutationContextType>(
        async (value) => {

            const model = await PageConfigurationService.getAccessiblePageConfiguration4(groupID, value.configurationID);

            await PageConfigurationService.deletePageConfiguration(
                groupID,
                model
            );

            return {
                deletedName: model.name
            };
        },
        {
            onMutate: async (value) => {

                const otherKeys = value.pageConfigurationType === PageConfigurationTypeEnum.SummaryListing_RTS ?
                    deviceSummaryKeys :
                    wellSummaryKeys;                

                await queryClient.cancelQueries(keys.all);
                await queryClient.cancelQueries(otherKeys.all);


                const previousConfigurations = queryClient.getQueryData<PageConfigurationDataModel3>(
                    otherKeys.configurationList(
                        groupID
                    )
                );

                if (previousConfigurations) {
                    queryClient.setQueryData<PageConfigurationDataModel3>(
                        otherKeys.configurationList(
                            groupID,
                        ),
                        (old?: PageConfigurationDataModel3) => {

                            const c = old as PageConfigurationDataModel3;
                            c.privateConfigurations = c.privateConfigurations?.filter(o => o.id !== value.configurationID);
                            c.sharedConfigurations = c.sharedConfigurations?.filter(o => o.id !== value.configurationID);
                            return c;
                        }
                    );
                }

                return {
                    previousConfigurations: previousConfigurations
                };
            },
            onError: onError,
            onSuccess: onSuccess,
            onSettled: (_data, error, item, context) => {

                const otherKeys = item.pageConfigurationType === PageConfigurationTypeEnum.SummaryListing_RTS ?
                deviceSummaryKeys :
                wellSummaryKeys;                

                if (error && context?.previousConfigurations) {


                    queryClient.setQueryData<PageConfigurationDataModel3>(
                        otherKeys.configurationList(
                            groupID,
                        ),
                        context?.previousConfigurations
                    );
                }

                queryClient.invalidateQueries(otherKeys.configurationLists());
            }
        }
    );
}
